@if (canViewAnalyses) {
  <div class="list-analyses-container">
    <ng-container>
      <div class="row bottom-margin">
        @if (!displayCreateAndDeleteAnalysisButtons()) {
          <div class="col-9">
            <span class="analysis-type-header">Single-Entity Analyses</span>
          </div>
        }
        @if (displayCreateAndDeleteAnalysisButtons()) {
          <div class="col-9">
            <button type="button" class="btn btn-primary btn-rounded" (click)="addAnalysis()"><i class="fas fa-plus"></i> Create New Analysis</button>
          </div>
        }
      </div>
      <div class="row bottom-margin">
        <div class="col-12">
          <table class="table table-bordered header-title">
            <tr class="table-header">
              <th>Analysis</th>
              <th>Date Created</th>
              <th>Proposed Loans</th>
              <th>Total Proposed Debt</th>
              <th></th>
            </tr>
            @if (analyses.length) {
              @for (analysis of analyses; track analysis; let i = $index) {
                <tr>
                  <td><a [routerLink]="['/companies/', company.uuid, 'analyses', analysis.uuid]"><button class="btn btn-link p-0">{{analysis.name}}</button></a></td>
                  <td>{{analysis.createdDate | amFromUtc | amDateFormat : 'MM/DD/YYYY'}}</td>
                  <td class="align-right">{{numProposedDebts(analysis)}}</td>
                  <td class="align-right">{{totalProposedDebt(analysis) | currency}}</td>
                  <td class="menu-td">
                    <div class="opener-container clickable" (click)="openAnalysisMenu(i)">
                      <i class="fas fa-chevron-circle-down"></i>
                    </div>
                    @if (i === openedAnalysisMenuIndex) {
                      <ul
                        class="dropdown-menu"
                        >
                        <li><a class="dropdown-item" [routerLink]="['/companies/', company.uuid, 'analyses', analysis.uuid]">Edit Analysis</a></li>
                        <li>@if (displayCreateAndDeleteAnalysisButtons()) {
                          <a class="dropdown-item" (click)="deleteAnalysis(analysis, i, $event);">Delete Analysis</a>
                        }</li>
                      </ul>
                    }
                  </td>
                </tr>
              }
            } @else {
              <tr>
                <td colspan="5" class="no-analyses-container">
                  @if (!analysesLoading) {
                    <div>
                      <app-table-empty-state
                        [helpText]="noAnalysesHelpText"
                      ></app-table-empty-state>
                    </div>
                  }
                  @if (analysesLoading) {
                    <div class="loader" style="margin-top: 20px; margin-bottom: 20px"></div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
    </ng-container>
    @if (isGlobalCashflowShown) {
      <div class="row bottom-margin">
        @if (!displayCreateAndDeleteAnalysisButtons()) {
          <div class="col-9">
            <span class="analysis-type-header">Multi-Entity Analyses</span>
          </div>
        }
        @if (displayCreateAndDeleteAnalysisButtons()) {
          <div class="col-9">
            <button type="button" class="btn btn-primary btn-rounded" (click)="addGlobalCashflow()"><i class="fas fa-plus"></i> Create New Global Cash Flow</button>
          </div>
        }
      </div>
      <div class="row bottom-margin">
        <div class="col-12">
          <table class="table table-bordered header-title">
            <tr class="table-header">
              <th>Analysis</th>
              <th>Date Created</th>
              <th>Proposed Loans</th>
              <th>Total Proposed Debt</th>
              <th></th>
            </tr>
            @if (globalCashflowAnalyses.length) {
              @for (analysis of globalCashflowAnalyses; track analysis; let i = $index) {
                <tr>
                  <td><a [routerLink]="['/companies/', company.uuid, 'global-cashflow-analyses', analysis.uuid]"><button class="btn btn-link p-0">{{analysis.name}}</button></a></td>
                  <td>{{analysis.createdDate | amFromUtc | amDateFormat : 'MM/DD/YYYY'}}</td>
                  <td class="align-right">{{numProposedDebts(analysis)}}</td>
                  <td class="align-right">{{totalProposedDebt(analysis) | currency}}</td>
                  <td class="menu-td">
                    <div class="opener-container clickable" (click)="openGlobalCashflowMenu(i)">
                      <i class="fas fa-chevron-circle-down"></i>
                    </div>
                    @if (i === openedGlobalCashflowMenuIndex) {
                      <ul
                        class="dropdown-menu"
                        >
                        <li><a class="dropdown-item" [routerLink]="['/companies/', company.uuid, 'global-cashflow-analyses', analysis.uuid]">Edit Analysis</a></li>
                        <li>@if (displayCreateAndDeleteAnalysisButtons()) {
                          <a class="dropdown-item" (click)="deleteGlobalCashflowAnalysis(analysis, i, $event);">Delete Analysis</a>
                        }</li>
                      </ul>
                    }
                  </td>
                </tr>
              }
            } @else {
              <tr>
                <td colspan="5" class="no-analyses-container">
                  @if (!globalCashflowAnalysesLoading) {
                    <div>
                      <app-table-empty-state
                        [helpText]="noGcfAnalysesHelpText"
                      ></app-table-empty-state>
                    </div>
                  }
                  @if (globalCashflowAnalysesLoading) {
                    <div class="loader" style="margin-top: 20px; margin-bottom: 20px"></div>
                  }
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </div>
} @else {
  <borrower-alert [alertText]="accessErrorText"></borrower-alert>
}

